import { DEBUG } from "../../../../config";
import { MapLoaiCuocToDB, MapLoaiCuocToDBEx } from "../../db/service/parserService";
import { isCuPhapMn } from "../../utils/common";
import { addMaCuocToHashMap, buildSMSMB, buildSMSMN, isXien3mien } from "../CanChuyenLib";

export interface StateKHoang {
    chuId: number;
    catItems: { tu: number, den: number, diem: number, dvt: string }[];

}
/**trả về danh sách tin nhắn sẽ chuyển đi*/
export function catChuyenTheoKhoang(dataCanChuyen: any, param: StateKHoang): [string[],any] {
    const mapResult: Map<string, any> = new Map();
    // key = dai1.dai2;loai;diem, values = day so cuoc
    const dataByDaiLoaiCuocId = extractByLoaiCuocId(dataCanChuyen);
    param.catItems.forEach(element => {
        const { tu, den, diem, dvt } = element;
        for (let i = tu; i <= den; i++) {
            const index = i - 1;
            //
            dataByDaiLoaiCuocId.forEach((datasMap, daiCombine) => {
                datasMap.forEach((values) => {
                    const value = values[index];
                    if (value) {
                        const row = getItemSeChuyen(value, diem, dvt);
                        if (row) {
                            let key = `${row.daiId1}.${row.daiId2};${row.loaiCuocId};${row.diemSeChuyen}`

                            if (isXien3mien(row.loaiCuocId)) {
                                if (isCuPhapMn())
                                    key = `${row.daiId1}.${row.daiId2};${row.loaiCuocId};${row.diemSeChuyen};${row.soCuoc}`

                            }
                            addMaCuocToHashMap(mapResult, key, row);
                            // if (DEBUG)
                            //     console.log(daiCombine, value, 'index=', index);
                        }

                    }
                });
            });

        }
    });
    let smss: string[] = [];
    if (isCuPhapMn())
        smss = buildSMSMN(mapResult, 2000);
    else
        smss = buildSMSMB(mapResult, 2000);
    // if (DEBUG){
    //     smss.forEach((element, index) => {
    //         console.log('sms', index, element);
    //     });
    // }
    //tới đây có map, chỉ việc build sms là xong
    return [smss,mapResult];

}
function getItemSeChuyen(dataItem: any, diem: number, dvt: string): any {
    const result = { ...dataItem };
    const diemThua: number = result.diemThua;
    let diemSeChuyen = diemThua;
    if (dvt == '%') {
        diemSeChuyen = diemThua * diem / 100;
    } else {
        if (diemThua < diem) {
            diemSeChuyen = diemThua;
        } else {
            diemSeChuyen = diem;
        }
    }
    result.diemSeChuyen = diemSeChuyen
    return result;
}
// trả về mảng tin nhắn sẽ chuyển đi
export function catChuyenTuyChon(dataCanChuyen: any, parserResult: any): [string[],Map<string, any> ] {
    const mapResult: Map<string, any> = new Map();
    //build sẵn key: dai:loại: số, mối item là 1 row
    const datas = extractByDaiLoaiCuocIdSoCuoc(dataCanChuyen);
    parserResult.compactData.forEach((element: any) => {
        const loaiCuocId = MapLoaiCuocToDB(element.loai, element.so, parserResult.region);
        const keyBySoCuoc = getKeyDaiLoaiCuocSoCuoc(getKeyDaiLoaiCuoc(element.dai, '', loaiCuocId), element.so);
        const data = datas.get(keyBySoCuoc);
        if (data) {
            const row = getItemSeChuyen(data, element.diem, element.dvt);
            if (row) {
                let key = `${row.daiId1}.${row.daiId2};${row.loaiCuocId};${row.diemSeChuyen}`

                if (isXien3mien(row.loaiCuocId)) {
                    if (isCuPhapMn())
                        key = `${row.daiId1}.${row.daiId2};${row.loaiCuocId};${row.diemSeChuyen};${row.soCuoc}`

                }
                addMaCuocToHashMap(mapResult, key, row);
            }
        }
    })
    let smss: string[] = [];
    if (isCuPhapMn())
        smss = buildSMSMN(mapResult, 2000);
    else
        smss = buildSMSMB(mapResult, 2000);
    // if (DEBUG){
    //     smss.forEach((element, index) => {
    //         console.log('sms', index, element);
    //     });
    // }
    //tới đây có map, chỉ việc build sms là xong
    return [smss,mapResult];
}
function getKeyDaiLoaiCuoc(daiId1: string, daiId2: string, loaiCuocId: string) {
    return `${getDaiCombine(daiId1, daiId2)}:${loaiCuocId}`;

}
function getDaiCombine(daiId1: string, daiId2: string) {
    return `${daiId1}${daiId2 != '' ? '.' + daiId2 : ''}`;
}
/**tách các loại cược ra từng phần tử trong Map riêng biệt để xử lý tiếp*/
export function extractByLoaiCuocId(dataCanChuyen: any): Map<string, Map<string, any[]>> {
    const result = new Map<string, Map<string, any[]>>();
    dataCanChuyen.dataCanChuyenStruct.forEach((element: any) => {
        const key = getKeyDaiLoaiCuoc(element.daiId1, element.daiId2, element.loaiCuocId);
        const daiCombine = getDaiCombine(element.daiId1, element.daiId2);

        let mapByDaiLoaiCuocId: Map<string, any> = new Map<string, any[]>();
        // chưa có thì tạo mới 1 map chứa dữ liệu của đài đó
        if (!result.has(daiCombine)) {
            result.set(daiCombine, mapByDaiLoaiCuocId);
        } else {
            mapByDaiLoaiCuocId = result.get(daiCombine)!;
        }
        let values = mapByDaiLoaiCuocId.get(key);
        if (!values) {
            values = [];
            mapByDaiLoaiCuocId.set(key, values);
        }
        values.push(element);

    });
    return result;
}
function getKeyDaiLoaiCuocSoCuoc(keyLoaiCuoc: string, soCuoc: string): string {
    return keyLoaiCuoc + `:${soCuoc}`;
}
export function extractByDaiLoaiCuocIdSoCuoc(dataCanChuyen: any): Map<string, any> {
    const result = new Map<string, any>();
    dataCanChuyen.dataCanChuyenStruct.forEach((element: any) => {
        const key = getKeyDaiLoaiCuocSoCuoc(getKeyDaiLoaiCuoc(element.daiId1, element.daiId2, element.loaiCuocId), element.soCuoc);
        result.set(key, element);

    });
    return result;
}
export function getLocalKeyCatKhoang(chuId:number):string{
    return `catKhoang:${chuId}`;
}
export function getLocalKeyCatTuyChon(chuId:number):string{
    return `catTuyChon:${chuId}`;
}